import i18next from 'i18next';
import { isPossiblePhoneNumber } from 'libphonenumber-js';
import { isNil } from 'lodash-es';
import * as Yup from 'yup';

const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

let isPossibleEmailAddressErrorMessage: string;
i18next.on('languageChanged', () => {
  isPossibleEmailAddressErrorMessage = i18next.t('is-possible-email-address', {
    ns: 'yup',
  });
});

Yup.addMethod(Yup.string, 'isPossibleEmailAddress', function (message?: string) {
  return this.test('test-email-address', (value, testContext) => {
    const { createError } = testContext;

    if (!value) {
      return true;
    }

    const isValidEmailAddress = EMAIL_REGEX.test(value);

    return isValidEmailAddress ? true : createError({ message: message ?? isPossibleEmailAddressErrorMessage });
  });
});

// ----------------------------------------------------------------------

Yup.addMethod(Yup.string, 'isPossiblePhoneNumber', function (message?: string) {
  return this.test('test-phone-number', (value, testContext) => {
    const { createError } = testContext;

    if (!value) {
      return true;
    }

    return isPossiblePhoneNumber(`+${value}`)
      ? true
      : createError({ message: message ?? 'Введите корректный номер телефона' });
  });
});

export type FileValidationOptions = {
  correctTypes: string[];
  maxSize: number;
  typeErrorMessage?: string;
  sizeErrorMessage?: string;
};
Yup.addMethod(Yup.mixed<File>, 'fileValidation', function (options: FileValidationOptions) {
  return this.test('file-validation', function (value, { createError }) {
    if (isNil(value)) return true;

    if (!options.correctTypes.includes(value.type)) {
      return createError({ message: options.typeErrorMessage ?? 'Выбран недопустимый формат файла' });
    }

    if (value.size > options.maxSize) {
      return createError({
        message: options.sizeErrorMessage ?? `Максимальный размер файла ${options.maxSize / (1024 * 1024)} Мб`,
      });
    }

    return true;
  });
});

// ----------------------------------------------------------------------

export { Yup };
